module.exports = __webpack_public_path__ + "static/img/fish35.fadc769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish35.png
// module id = A/sL
// module chunks = 0